export default __webpack_public_path__ + "static/media/uploadImgArrow.7f13cbe8.svg";